import { render, staticRenderFns } from "./Create-Service-Form.vue?vue&type=template&id=358d9210"
import script from "./Create-Service-Form.vue?vue&type=script&lang=js"
export * from "./Create-Service-Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports